import type { IconDef } from '../types';

export const leftChevron: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M17 0C17.26 0 17.51 0.100031 17.71 0.290091C18.1 0.680212 18.1 1.31041 17.71 1.70053L7.41 12.0038L17.7 22.297C18.09 22.6871 18.09 23.3173 17.7 23.7074C17.31 24.0975 16.68 24.0975 16.29 23.7074L5.29 12.714C5.1 12.5239 5 12.2738 5 12.0038C5 11.7337 5.11 11.4836 5.29 11.2935L16.29 0.290091C16.49 0.0900281 16.74 0 17 0Z',
    },
  ],
};
